import React, { FC } from 'react';
import { Text } from '@sravni/react-design-system/lib/Typography';
import { FORM_FIELDS, LABELS } from '../../../../../constants';
import styles from './styles.module.scss';
import {
    LastExperienceStartMonthField,
    LastExperienceStartYearField,
} from '../../../../../helpers/form.new/fields/work';
import { UseFormReturn } from 'react-hook-form';

interface LastExperienceProps {
    form: UseFormReturn;
}

export const LastExperienceFields: FC<LastExperienceProps> = (props) => {
    const { form } = props;
    const {
        control,
        formState: { errors, dirtyFields: _ },
    } = form;

    return (
        <div className={styles['last-experience']}>
            <Text size={14} className={styles['last-experience__label']}>
                {LABELS[FORM_FIELDS.LAST_EXPERIENCE]}
            </Text>

            <div className={styles['last-experience__fields']}>
                <div className={styles['field']}>
                    <LastExperienceStartMonthField
                        control={control}
                        error={errors[FORM_FIELDS.LAST_EXPERIENCE_START_MONTH]?.message}
                    />
                </div>

                <div className={styles['field']}>
                    <LastExperienceStartYearField
                        control={control}
                        error={errors[FORM_FIELDS.LAST_EXPERIENCE_START_YEAR]?.message}
                    />
                </div>
            </div>
        </div>
    );
};
